import { useNavigate, useParams } from 'react-router-dom';
import { ESDM_ITEMS, ESDM_LEVEL_AGE_BANDS, getDomainsForLevel, getEsdmDomainRollup } from '@aba-denver/core';
import type { EsdmLevel } from '@aba-denver/core';
import { useData } from '../contexts/DataContext';

export function EsdmLevelDomains() {
  const { id, level: levelParam } = useParams();
  const navigate = useNavigate();
  const { getChildById, getChildEsdmProgress } = useData();

  const child = id ? getChildById(id) : undefined;
  const level = Number(levelParam) as EsdmLevel;

  if (!child) {
    return <div className="empty-state">Paciente não encontrado.</div>;
  }

  const domains = getDomainsForLevel(level);
  const progressDoc = getChildEsdmProgress(child.id);
  const rollup = getEsdmDomainRollup(ESDM_ITEMS, progressDoc?.items ?? {}).filter((r) => r.level === level);

  return (
    <div>
      <div className="page-header">
        <div>
          <a onClick={() => navigate(`/patients/${child.id}/esdm`)} style={{ cursor: 'pointer', fontSize: 13 }}>
            ‹ Checklist ESDM
          </a>
          <h1 style={{ marginTop: 6 }}>Nível {level}</h1>
          <p className="muted" style={{ margin: 0 }}>{ESDM_LEVEL_AGE_BANDS[level]}</p>
        </div>
      </div>

      <div className="stack">
        {domains.map((domain) => {
          const domainRollup = rollup.find((r) => r.domain === domain.code);
          const acquired = domainRollup?.acquired ?? 0;
          const total = domainRollup?.total ?? 0;
          const pct = total > 0 ? Math.round((acquired / total) * 100) : 0;
          return (
            <div
              key={domain.code}
              className="card"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/patients/${child.id}/esdm/${level}/${domain.code}`)}
            >
              <div className="row" style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ fontWeight: 600 }}>{domain.name}</div>
                <div className="muted" style={{ fontSize: 13 }}>{acquired} de {total} adquiridos</div>
              </div>
              <div className="progress-track" style={{ marginTop: 10 }}>
                <div className="progress-fill" style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
